export const onClientEntry = () => {
  window.onload = () => {
    if (window && "gtag" in window) return;
    window.gtag = gtagDummy;
  };
};

function gtagDummy() {
  let args = Array.from(arguments);

  const command = args.shift();

  let pArgs = [];
  let namedArgs = [];

  args.forEach((arg) => {
    if (typeof arg === "string") {
      pArgs.push(arg);
    } else if (typeof arg === "object") {
      if (arg && Object.keys(arg).length !== 0 && arg.constructor === Object) {
        for (const [key, value] of Object.entries(arg)) {
          namedArgs.push(`${key}: ${value}`);
        }
      }
    }
  });

  let front = `DEBUG gtag: command[${command}]`;
  let argText = (pArgs.length > 0 && `, args[${pArgs.join(", ")}]`) || "";
  let namedText =
    (namedArgs.length > 0 && `, namedArgs[${namedArgs.join(", ")}]`) || "";

  console.debug(`${front}${argText}${namedText}`);
}

export const onRouteUpdate = () => {
  [...document.links].forEach((a) => {
    if (
      !a.href.match(/^mailto:/) &&
      a.hostname != location.hostname &&
      !a.href.match(/^javascript:/) &&
      !a.href.match(/^$/)
    ) {
      a.target = "_blank";
    }
  });

  document.querySelectorAll("[role=button]").forEach((button) => {
    button.addEventListener("keydown", (evt) => {
      // evt.key && evt.keycode have mixed support
      // keycode is deprecated but support is greater than e.key
      const keyD = evt.key !== undefined ? evt.key : evt.keyCode;

      // In IE11 and lower, e.key will equal "Spacebar" instead of ' '
      if (
        keyD === "Enter" ||
        keyD === 13 ||
        ["Spacebar", " "].indexOf(keyD) >= 0 ||
        keyD === 32
      ) {
        // Default behavior is prevented to prevent the page to scroll when "space" is pressed
        evt.preventDefault();
        evt.currentTarget.click();
      }
    });
  });

  document.querySelectorAll("[data-nobreak=arrow]").forEach((arrowLink) => {
    if (arrowLink.hasAttribute("data-arrowfix")) return;

    arrowLink.setAttribute("data-arrowfix", "");

    const [textNode, svg] = arrowLink.childNodes;
    let text = textNode.data;
    if (!text) return;
    let words = text.split(/\s/);
    let lastWord = words.pop();
    let noBreak = `<span class="nobreak">${lastWord}${svg.outerHTML}</span>`;
    words.push(noBreak);

    arrowLink.innerHTML = words.join(" ");
  });
};
